import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { curdDemandPageMixin } from '@/views/demand/mixin/demand';
import DeliverForm from './form.vue';
import ActionBar from './action-bar.vue';
import DemandInfo from '../components/demand-info.vue';
import { getAppTagList } from '@/api/system/app-tag.js';

export default {
  components: {
    DeliverForm: DeliverForm,
    ActionBar: ActionBar,
    DemandInfo: DemandInfo
  },

  // data: demand/creationList/products; methods: getDemandDetail
  mixins: [curdDemandPageMixin],

  data: function data() {
    return {
      deliverGroupList: [],
      tagData: {
        // 特征标签数据
        featureTagData: [],
        // 产品标签数据
        appTagData: [],
        app_cat_ids: ''
      }
    };
  },


  computed: {
    demandId: function demandId() {
      return Number(this.$route.params.id) || '';
    }
  },

  mounted: function mounted() {
    if (this.demandId) {
      this.getDemandDetail(this.demandId);
      this.getFeatureTagData();
    }
  },


  methods: {
    updateDeliverGroupList: function updateDeliverGroupList(list) {
      this.deliverGroupList = list;
    },
    getFeatureTagData: function getFeatureTagData() {
      var _this = this;

      this.loading = true;
      getAppTagList({
        type: 1
      }).then(function (res) {
        var list = _.get(res, 'data.data.tag.sub_tags', []);
        _this.tagData.featureTagData = list;
      }).catch(function () {
        _this.loading = false;
      });
    },
    validate: function validate() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var validateList, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validateList = [];

                if (_.get(_this2.$refs, 'deliver-form.$refs.meta-info')) {
                  validateList.push(_this2.$refs['deliver-form'].$refs['meta-info'].validate());
                }
                _this2.$refs['deliver-form'].$refs['deliver-group-list'].$refs.deliver.forEach(function (item) {
                  validateList.push(item.validate());
                });
                _this2.$refs['deliver-form'].$refs['productForm'].forEach(function (e) {
                  validateList.push(e.validate());
                });

                _context.prev = 4;
                _context.next = 7;
                return _Promise.all(validateList);

              case 7:
                res = _context.sent;

                console.log(res);

                if (!res.every(function (item) {
                  return item === true;
                })) {
                  _context.next = 12;
                  break;
                }

                console.log('验证通过');
                return _context.abrupt('return', true);

              case 12:
                return _context.abrupt('return', false);

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](4);

                console.log('验证不通过');
                return _context.abrupt('return', false);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 15]]);
      }))();
    },
    saveAppInfo: function saveAppInfo(fn) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var submitList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                submitList = [];

                _this3.$refs['deliver-form'].$refs['productForm'].forEach(function (e) {
                  if (!e.readOnly) {
                    submitList.push(e.saveAppInfo());
                  }
                });
                if (submitList.length) {
                  _Promise.all(submitList).then(function (res) {
                    fn && fn();
                  }).catch(function (res) {
                    console.log(res);
                  });
                } else {
                  fn && fn();
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
};